import React from 'react';

const Title = (props) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <h1>{props.titulo1}<span className="color-green">{props.titulo2}</span>{props.titulo3}</h1>
            </div>
        </div>
    );
};

export default Title;